(function (appComponents) {

	// move to proto
	var searchOrdersView = function (parent) {
		var view = {
			_helpers: parent._helpers,
			_b2bUnit: parent._b2bUnit,
			_orders: parent._orders,
			_templates: parent.templates,
			_modals: parent._modals,
			_messages: parent._messages,
			_utils: parent._utils,
			context: Object.create(parent.context),
			parent: parent
		};

		view.name = "searchOrders";

		view.currentTabView = "list";

		view.savedQueryData = null;

		view.pager = view._helpers.getPager(view);

		view.opts = {
			numToDisplay: 12
		};

		view.context.pagerData = view.pager.data;

		view.elements = {
			get searchResultsNum() {
				return $('[pc-container="orders--search-results-number"]');
			},
			get searchOrdersResults() {
				return $('[pc-container="orders--search-orders-results"]');
			}
		};

		view.prepareSearchData = function () {
			var searchData = view.parent._queryData;


			if (searchData.view != view.name) {
				// initial search data
				searchData = {};
				searchData.view = view.name;
				searchData.resultsPerPage = view.opts.numToDisplay;
				searchData.pageNumber = 1;

				if (view.parent.currentView == view.name) {
					view.parent._updateUrlQuery("replace", searchData);
				}
			}

			view.savedQueryData = searchData;

			return $.extend(true, {}, searchData);
		};

		view.parseGetOrdersResponse = function (data, searchData) {
			view.pager.data = data.pagination;
			view.context.pagerData = view.pager.data;
			view.context.orders = data.results;
			view.context.searchData = searchData;

		};

		view.checkTabView = function () {
			if (view.currentTabView == "list") {
				view.context.listTabActiveClass = "active";
				view.context.gridTabActiveClass = "";
				$("#list_order").addClass("active");
				$("#grid_order").removeClass("active");
			} else if (view.currentTabView == "grid") {
				view.context.listTabActiveClass = "";
				view.context.gridTabActiveClass = "active";
				$("#grid_order").addClass("active");
				$("#list_order").removeClass("active");
			}
		};

		view.renderSearchResults = function (ignoreAnim) {
			view.checkTabView();

			view.renderSearchOrders(ignoreAnim);
			view.updateSearchResultsNum();
		};

		view.renderSearchOrders = function (ignoreAnim) {
			var html = view._templates.searchOrdersResults(view.context);
			if (ignoreAnim) {
				view.elements.searchOrdersResults.html(html);
			} else {
				view.elements.searchOrdersResults.hide().html(html).fadeIn("fast");
			}
		};

		view.updateSearchResultsNum = function () {
			view.elements.searchResultsNum.text(view.pager.data.totalNumberOfResults);
		};

		view.searchOrdersWithPager = function (ignoreAnim) {
			var searchData = view.prepareSearchData();

			view._orders.search(searchData).then(function (data) {
				if (data && data.results) {
                    if(data.pagination.totalNumberOfResults === 0){
                        $('[pc-container="orders--export-to-excel-button"]').hide();
                 }else if(data.pagination.totalNumberOfResults >= 1){
                        $('[pc-container="orders--export-to-excel-button"]').show();
                 }
					view.parseGetOrdersResponse(data, searchData);
					view.renderSearchResults(ignoreAnim);
				}
			});
		};

		view.resetFilters = function () {
			view.pager.reset();
			var filtersForm = view.parent.elements.filtersForm[0];
			view.handlers.onFilterFormSubmit(filtersForm);
		};

		view.updateQueryRoutine = function (searchData) {
			if (!searchData) {
				searchData = view.parent._queryData;
			}

			var pagerData = {
				pageNumber: view.pager.pageToSet,
				resultsPerPage: view.pager.pageSize
			};

			var queryData = jQuery.extend({}, searchData, pagerData);

			queryData.view = view.name;

			view.savedQueryData = queryData;

			view.parent._updateUrlQuery("push", queryData);

		};

		view.handlers = {
			onSetTabView: function (type) {
				view.currentTabView = type;
			},
			onFilterFormSubmit: function (form) {
				var access = view._b2bUnit.checkB2BUnit();
				if (!access) {
					view._modals.warning.show(view._messages.noB2bUnitSelected);
					return;
				}

				var formData = view._utils.getFormData(form);

				formData = view._utils.removeEmptyProps(formData);

				view.pager.reset();

				view.updateQueryRoutine(formData);

				view.searchOrdersWithPager();
			},

			pager: {
				onPagerClick: function () {
					view.updateQueryRoutine();
					view.searchOrdersWithPager("ignoreAnim");
				}
			}
		};

		view.init = function () {

			if (view.savedQueryData) {
				view.parent._updateUrlQuery("push", view.savedQueryData);
			}

			view.pager.init();
		};

		return view;
	};


	if (appComponents.pageComponents == null) appComponents.pageComponents = {};
	if (appComponents.pageComponents.ordersOverview == null) appComponents.pageComponents.ordersOverview = {};
	appComponents.pageComponents.ordersOverview.searchOrdersView = searchOrdersView;

	window.appComponents = appComponents;

})(window.appComponents || {});